/** Gemeinsame flüchtige Entwürfe für Vollchat und Messenger; niemals Browser-Speicher. */
import type { ChatFileView } from '@till-erp/chat/values';
import { createChatMemory, onChatMemoryClear } from './chat-memory.ts';
export interface ChatDraftFile {
  id: string;
  file: File;
  preview: string | null;
  state: 'selected' | 'uploading' | 'ready' | 'failed' | 'cancelled' | 'removing' | 'remove-failed';
  progress: number;
  error: string | null;
  uploaded: ChatFileView | null;
  cancel?: (() => void) | undefined;
  /** Upload abgeschickt: ohne bestätigte Antwort kann der Server die Datei trotzdem gespeichert haben. */
  attempted?: boolean | undefined;
}
export interface ChatDraft { text: string; files: ChatDraftFile[] }
const empty: ChatDraft = { text: '', files: [] };
export interface ChatPendingMessage { key: string; body: string; files: ChatFileView[]; createdAt: string; state: 'sending' | 'failed'; error: string | null }
export const chatPendingByChannel = createChatMemory<ChatPendingMessage[]>();
const sending = new Set<string>();
export function claimChatDraftSend(key: string) { if (sending.has(key)) return false; sending.add(key); return true; }
export function releaseChatDraftSend(key: string) { sending.delete(key); }
const drafts = new Map<string, ChatDraft>();
const listeners = new Set<() => void>();
export const chatDraftKey = (userId: string, channelId: string, draftScope?: string) => `${userId}:${channelId}${draftScope ? `:${draftScope}` : ''}`;
export const readChatDraft = (key: string) => drafts.get(key) ?? empty;
export function subscribeChatDraft(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
export function updateChatDraft(key: string, update: (draft: ChatDraft) => ChatDraft) {
  drafts.set(key, update(readChatDraft(key)));
  for (const listener of listeners) listener();
}
export function clearChatDraft(key: string) {
  for (const file of drafts.get(key)?.files ?? []) { file.cancel?.(); if (file.preview) URL.revokeObjectURL(file.preview); }
  drafts.delete(key);
  sending.delete(key);
  for (const listener of listeners) listener();
}
export function clearChatDrafts() { for (const key of drafts.keys()) clearChatDraft(key); chatPendingByChannel.clear(); sending.clear(); }
export function clearChatConversationDraft(userId: string, channelId: string) {
  const base = chatDraftKey(userId, channelId);
  for (const key of new Set([...drafts.keys(), ...chatPendingByChannel.keys()])) {
    if (key === base || key.startsWith(`${base}:`)) { clearChatDraft(key); chatPendingByChannel.delete(key); }
  }
}
// Bestätigter Rechte- oder Mitgliedschaftsentzug (24.2) löscht auch Text, Anhänge und wartende Nachrichten des Composers.
onChatMemoryClear((userId, allowedChannels) => {
  for (const key of [...drafts.keys()]) {
    if (key.startsWith(`${userId}:`) && !allowedChannels?.has(key.split(':')[1])) clearChatDraft(key);
  }
});

